/** Signal Guide — glossary page (sidebar). */

import React from "react";
import {
  SIGNAL_GUIDE_INTRO,
  SIGNAL_GUIDE_VERDICTS,
  SIGNAL_GUIDE_CONFLUENCE,
  SIGNAL_GUIDE_TIERS,
  SIGNAL_GUIDE_COLUMNS,
} from "./signalTooltips.js";

function Card({ title, children, T }) {
  return (
    <div style={{ background: T.bg, border: `1px solid ${T.border}`, borderRadius: 12, padding: "16px 18px", marginBottom: 14 }}>
      {title && <div style={{ fontSize: 11, fontWeight: 800, color: T.purple, letterSpacing: "0.08em", marginBottom: 10 }}>{title}</div>}
      {children}
    </div>
  );
}

function Row({ label, body, T }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: T.text, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 12, color: T.textSub, lineHeight: 1.65 }}>{body}</div>
    </div>
  );
}

export function SignalGuidePanel({ T, onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 500, background: "rgba(0,0,0,0.65)", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "24px 16px", overflowY: "auto" }}
      onClick={onClose}>
      <div style={{ width: "100%", maxWidth: 720, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, boxShadow: "0 24px 64px rgba(0,0,0,0.45)", margin: "auto" }}
        onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: "18px 20px", borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 900, color: T.text }}>How Auctus Signals Work</div>
            <div style={{ fontSize: 11, color: T.textDim, marginTop: 4 }}>Verdicts, confluence, scoring tiers, and watchlist columns</div>
          </div>
          <button type="button" onClick={onClose} style={{ padding: "6px 12px", background: T.surfaceHi, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, cursor: "pointer", fontFamily: "inherit" }}>Close</button>
        </div>
        <div style={{ padding: "20px 22px", maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
          <Card title="HOW SIGNALS WORK" T={T}>
            {SIGNAL_GUIDE_INTRO.map((para, i) => (
              <p key={i} style={{ fontSize: 12, color: T.textSub, lineHeight: 1.75, margin: i < SIGNAL_GUIDE_INTRO.length - 1 ? "0 0 12px 0" : 0 }}>{para}</p>
            ))}
          </Card>

          <Card title="VERDICT SIGNALS" T={T}>
            {SIGNAL_GUIDE_VERDICTS.map((r) => (
              <Row key={r.label} label={r.label} body={r.body} T={T} />
            ))}
          </Card>

          <Card title="CONFLUENCE TYPES" T={T}>
            {SIGNAL_GUIDE_CONFLUENCE.map((r) => (
              <Row key={r.label} label={r.label} body={r.body} T={T} />
            ))}
          </Card>

          <Card title="SCORING TIERS" T={T}>
            {SIGNAL_GUIDE_TIERS.map((r) => (
              <Row key={r.label} label={r.label} body={r.body} T={T} />
            ))}
          </Card>

          <Card title="WATCHLIST COLUMNS" T={T}>
            {SIGNAL_GUIDE_COLUMNS.map((r) => (
              <Row key={r.label} label={r.label} body={r.body} T={T} />
            ))}
          </Card>
        </div>
      </div>
    </div>
  );
}
